import { render, staticRenderFns } from "./Newsfeed.vue?vue&type=template&id=3d1bcec8"
import script from "./Newsfeed.vue?vue&type=script&lang=js"
export * from "./Newsfeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports